import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/shell/AppShell';
import { RequireAuth } from '@/auth/RequireAuth';
import { RequireAdmin } from '@/auth/RequireAdmin';
import { RequireReports } from '@/auth/RequireReports';
import { RequireContent } from '@/auth/RequireContent';
import { RequireAssistant } from '@/auth/RequireAssistant';
import { SignInPage, SignUpPage } from '@/routes/AuthPages';
import { AnswerPage } from '@/routes/AnswerPage';
import { Overview } from '@/routes/Overview';
import { LeadIQ } from '@/routes/LeadIQ';
import { TrafficIQ } from '@/routes/TrafficIQ';
import { CampaignIQ } from '@/routes/CampaignIQ';
import { ReviewsIQ } from '@/routes/ReviewsIQ';
import { ConversationIQ } from '@/routes/ConversationIQ';
import { ContentIQ } from '@/routes/ContentIQ';
import { ExpertStudio } from '@/routes/ExpertStudio';
import { Admin } from '@/routes/Admin';
import { AdminClientPage } from '@/routes/AdminClient';
import { AssistantPage } from '@/routes/Assistant';
import { ReferralRewards } from '@/routes/ReferralRewards';

export function App() {
  return (
    <Routes>
      {/* Public auth screens */}
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />

      {/* The client's gap-question screen, reached from a link in an email with
          no login. Outside RequireAuth because the token IS the credential, and
          outside AppShell because a phone does not want dashboard chrome. */}
      <Route path="/answer/:token" element={<AnswerPage />} />

      {/* Everything below requires a signed-in user */}
      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          {/* Reports — hidden from Contributors (contentIQ + Expert Studio only) */}
          <Route element={<RequireReports />}>
            <Route index element={<Overview />} />
            <Route path="leads" element={<LeadIQ />} />
            <Route path="traffic" element={<TrafficIQ />} />
            <Route path="campaigns" element={<CampaignIQ />} />
            <Route path="reviews" element={<ReviewsIQ />} />
            <Route path="conversation" element={<ConversationIQ />} />
          </Route>
          <Route element={<RequireContent />}>
            <Route path="content" element={<ContentIQ />} />
          </Route>
          <Route path="studio" element={<ExpertStudio />} />
          <Route path="referrals" element={<ReferralRewards />} />
          <Route element={<RequireAssistant />}>
            <Route path="assistant" element={<AssistantPage />} />
          </Route>

          {/* Triton-admin-only */}
          <Route element={<RequireAdmin />}>
            <Route path="admin" element={<Admin />} />
            <Route path="admin/clients/:orgId" element={<AdminClientPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
